import { baseApi } from "./baseApi";

export const adminApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAdminDetails: builder.query({
      query: (preferredUsername) =>
        `doc-aide-svc/admin?AdminID=${preferredUsername}`,
      transformResponse: (response) => response.Admin,
    }),

    createUser: builder.mutation({
      query: (user) => ({
        url: "/users",
        method: "POST",
        body: user,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetAdminDetailsQuery, useCreateUserMutation } = adminApi;
